import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const createPigmyService = async (formData) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/pigmy/create-pigmy`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Pigmy Creation failed. Please try again."
    );
  }
};
export const getCustomerPigmysService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/pigmy/get-customer-pigmys/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Pigms fetching failed. Please try again."
    );
  }
};
export const getCustomerPigmyDetailService = async (id) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${API_URL}/pigmy/get-pigmy-details/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.pigmy;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Pigmy fetching failed. Please try again."
    );
  }
};
export const getPigmyCollectionsService = async (
  pigmyId,
  page,
  rowsPerPage
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/pigmy/get-customer-pigmy-collection`,
      {
        params: {
          pigmyId,
          page,
          limit: rowsPerPage, // use 'limit' for rows per page
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching pigmy collections"
    );
  }
};
export const getTodayPigmyCollectionsService = async (pigmyId) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/pigmy/get-pigmy-collection-by-date`,
      {
        params: {
          pigmyId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.pigmyCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching pigmy collections"
    );
  }
};
export const updatePigmyCollectionsService = async (
  pigmyId,
  collectionDate,
  collectionAmount
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/pigmy/update-pigmy-collection`,
      { collectionDate, collectionAmount },
      {
        params: {
          pigmyCollectionId: pigmyId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data?.pigmyCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching pigmy collections"
    );
  }
};
export const fetchTodayPigmyCollections = async (page, rowsPerPage) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/pigmy/get-today-pigmy-collections`,
      {
        params: {
          page:page + 1,
          limit: rowsPerPage, // use 'limit' for rows per page
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching pigmy collections"
    );
  }
};
export const fetchPigmyEnquiresService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  status
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/pigmy/get-pigmy-requests`, {
      params: {
        fromDate,
        toDate,
        page: page + 1,
        limit: rowsPerPage,
        status,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
export const fetchPigmyWithdrawRequestService = async (
  fromDate,
  toDate,
  page,
  rowsPerPage,
  status
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/pigmy/get-pigmy-withdraw-requests`,
      {
        params: {
          fromDate,
          toDate,
          page: page + 1,
          limit: rowsPerPage,
          status,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
export const createGroupPigmyService = async (formData) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/pigmy/create-group-pigmy`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message || "Loan Creation failed. Please try again."
    );
  }
};

export const updatePigmyWithdrawStatusService = async (id, status, userId) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.put(
      `${API_URL}/pigmy/update-pigmy-withdraw-request`,
      { id, status, userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message || "Loan Creation failed. Please try again."
    );
  }
};
